<div class="acquisition">
    <div class="acquisition-title">Target for Workshop Acquisition</div>
    <div class="acquisition-box">
        <div class="acquisition__chart-container flex-v-center">
            <div class="acquisition__chart-box">
                <div id="acquisitionRatePie" class="acquisition__chart-pie"></div>
                <div class="acquisition__chart-rate">
                    <div class="acquisition__chart-data">
                        <div class="acquisition__chart-name">Achievement Rate</div>
                        <!-- <div class="acquisition__chart-value">{{data.actualCustomer || 0}}/{{data.targetCustomer || 0}}</div> -->
                    </div>
                    <div>{{data.customerAchievementRate || 0}}%</div>
                </div>
            </div>
            <div class="acquisition_value_wrap flex">
                <div class="acquisition_value mr30">
                    <div class="desc">Workshop Acquisition Target Quantity</div>
                    <div class="value">
                        <span>{{ data.targetCustomer || 0}}</span>
                    </div>
                </div>
                <div class="acquisition_value actual">
                    <div class="desc">YTD Actual Workshop Acquisition</div>
                    <div class="value">
                        <span>{{ data.actualCustomer || 0}}</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="acquisition__detail">
            <div class="acquisition__detail-item" *ngFor="let item of data.expandCustomerItems">
                <div class="acquisition__detail-name">{{CustomerExpansionSplitMethods[data.expandCustomerSplitMethod ||
                    'BY_MONTH'][item.serialNo-1]}}</div>
                <div class="acquisition__detail-percent">
                    <div class="actived" [ngStyle]="{ 'width': item.actualCustomer/item.targetCustomer*100 + '%' }"></div>
                </div>
                <div class="acquisition__detail-data">
                    <span class="actual">{{item.actualCustomer}}</span>/<span class="target">{{item.targetCustomer}}</span>
                </div>
            </div>
        </div> -->
    </div>
    <div class="statistic">
        <div class="overview-title">
            Achievement by Month
        </div>
        <div class="statistic__chart-content">
            <div class="statistic__chart-box">
                <div id="acquisitionChart" class="statistic__chart chart"></div>
            </div>
        </div>
    </div>
</div>